import { render } from "./LocalNews.vue?vue&type=template&id=f420fedc&scoped=true"
import script from "./LocalNews.vue?vue&type=script&lang=js"
export * from "./LocalNews.vue?vue&type=script&lang=js"

import "./LocalNews.vue?vue&type=style&index=0&id=f420fedc&scoped=true&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f420fedc"]])

export default __exports__